import Pages from "layouts/Pages/Pages.jsx";

var indexRoutes = [{ path: "/", name: "Claim", component: Pages }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx